import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanRulesTemplate } from "../../domain/models/plan-rules-template";
import { PlanRulesTemplateRepository } from "../../repositories/plan-rules-template.repository";

@Injectable({ providedIn: 'root' })
export class GetPlanRulesTemplateByPlanIdUsecase implements UseCase<string, PlanRulesTemplate> {

  constructor(private readonly planRulesTemplateRepository: PlanRulesTemplateRepository) {
  }

  execute( params: string): Observable<PlanRulesTemplate> {
    return this.planRulesTemplateRepository.GetPlanRulesTemplateByPlanId(params);
  }

}
